/**
 * Mapeia códigos de erro de extração de fatura para mensagens amigáveis ao usuário.
 * Retorna null para erros com conteúdo JSX/interativo (1101, 1102, 1103, 2002,
 * 2004) — tratados inline no componente (campo de senha / links de ajuda / aviso).
 */
export const getInvoiceUploadErrorMessage = (code: string): string | null => {
  switch (code) {
    case '2001':
      return 'O arquivo enviado não está no padrão correto. Por favor, envie sua fatura de energia em formato PDF.';
    case '2003':
      return 'O arquivo enviado não é uma fatura de energia. Por favor, envie sua conta de energia elétrica em PDF.';
    case '1101':
    case '1102': // PDF protegido — pede o CPF/CNPJ inline (campo no componente)
    case '1103':
    case '2002': // PDF escaneado — JSX com link para tutorial de download do PDF texto
    case '2004': // distribuidora não suportada — JSX com botão "me avise"
      return null;
    default:
      return code;
  }
};

export const INVOICE_ERROR_CODES = {
  NOT_PDF: '2001',
  SCANNED_PDF: '2002',
  NOT_ENERGY_INVOICE: '2003',
  UNSUPPORTED_UTILITY: '2004',
  PASSWORD_WRONG_CPF: '1101',
  PASSWORD_REQUIRED: '1102',
  PASSWORD_LOCKED: '1103',
} as const;
